<template>
  <div class="usersprofile">
    <NavBar />
    <AuthBySessionExpired />
    <new-user-profile @created="paginate" />
    <view-user-profile
      :user_profile="user_profile"
      @updated="paginate"
      @close="user_profile = null"
    />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
            <v-btn class="btn-return" @click="$router.go(-1)">
              <i class="fas fa-arrow-left mr-2 text-twenty"> </i> Voltar
            </v-btn>
          </div>
          <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
            <h1 class="title-pages pt-1 check-text-center">
              PERFIL DE USUÁRIOS
            </h1>
          </div>
          <div
            class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right"
          >
            <v-btn
              v-if="permission('write', 'user_profile')"
              class="btn-add"
              @click="$bvModal.show('new_user_profile')"
            >
              <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
            </v-btn>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-3 col-lg-5 col-md-5 col-sm-6 col-12 pt-0 pb-1">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar perfil de usuários"
              dense
              outlined
            />
          </div>
        </div>
        <div class="v-clean p-5 text-center" v-show="userProfiles.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="userProfiles.length > 0"
          v-if="permission('read', 'user_profile')"
          dense
          :headers="headers"
          :items="userProfiles"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              v-if="item.name != 'MASTER'"
              small
              @click="user_profile = item"
              class="btn-edit m-1"
            >
              <i class="fas fa-pen mr-2 text-twenty"></i>
              EDITAR
            </v-btn>
          </template>
        </v-data-table>
        <errors-messages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import api from "../services/api";

import permission from "../lib/permission";

import ErrorsMessages from "../templates/Components/ErrorsMessages.vue";
import NewUserProfile from "../templates/UserProfile/new-user-profile.vue";
import ViewUserProfile from "../templates/UserProfile/view-user-profile.vue";

export default {
  name: "UsersProfile",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    NewUserProfile,
    ViewUserProfile,
  },

  data() {
    return {
      errors: [],
      loading: false,

      search: "",
      headers: [
        { text: "NOME", value: "name" },
        { text: "AÇÕES", value: "actions" },
      ],
      userProfiles: [],

      user_profile: null,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    async retrieve() {
      await this.paginate();
    },

    async paginate() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/profiles/paginate");
        const { error, errors, profiles } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.userProfiles = profiles;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
